import {Button} from '@mui/material';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import {useLocation, useNavigate} from 'react-router-dom';
import {APP_VERSION} from '../../common/appVersion';
import {normalizeApiError} from '../../common/apiErrors';
import {FeedbackContext} from '../../models/Feedback';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

type Props = {
    traceId?: string;
    error?: unknown;
    size?: 'small' | 'medium' | 'large';
};

export default function ReportProblemButton({traceId, error, size = 'small'}: Props) {
    const {t} = useAppTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const report = () => {
        const problem = error ? normalizeApiError(error) : undefined;
        const currentPage = `${location.pathname}${location.search}`.slice(0, 500);
        const context: FeedbackContext = {
            type: 'Bug',
            relatedTraceId: traceId || problem?.traceId || undefined,
            currentPage,
            appVersion: APP_VERSION,
            technicalContext: problem ? JSON.stringify({
                code: problem.code,
                status: problem.status,
                instance: problem.instance || undefined,
                userAgent: navigator.userAgent,
            }) : JSON.stringify({userAgent: navigator.userAgent}),
        };
        navigate('/app/feedback', {state: {feedbackContext: context}});
    };

    return <Button color="inherit" size={size} startIcon={<BugReportOutlinedIcon/>} onClick={report} sx={{mt: .5}}>{t('feedback:report_problem' as never)}</Button>;
}
